import PatentSetEdit from "./PatentSetEdit";

export default {
    Edit: PatentSetEdit
};
